import { useHaptics } from '@/hooks/use-haptics';
import { ElementProps, Flex, Text, UnstyledButton, UnstyledButtonProps } from '@mantine/core';
import { IconProps } from '@tabler/icons-react';
import { createElement, FunctionComponent } from 'react';
import styles from './styles.module.css';

interface MyUnstyledButtonProps
	extends UnstyledButtonProps,
		ElementProps<'button', keyof UnstyledButtonProps> {}

type CompactTileButtonProps = MyUnstyledButtonProps & {
	icon: FunctionComponent<IconProps>;
	text: string;
};

export const CompactTileButton = ({ icon, text, ...props }: CompactTileButtonProps) => {
	const onClick = useHaptics(props);

	return (
		<UnstyledButton component="button" {...props} onClick={onClick} className={styles.button}>
			<Flex justify="center" align="center" direction="row" gap="sm">
				{createElement(icon, { size: 20, color: 'var(--mantine-color-green-6)' })}
				<Text ta="center" fw="600" size="sm">
					{text}
				</Text>
			</Flex>
		</UnstyledButton>
	);
};
